import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FLOW_NODES } from '../../data/walkthrough.fixtures';

/**
 * Pane 4 / 8 — `The engine · 2 of 2` (specs/auth.md §5.4).
 *
 * ---------------------------------------------------------------------------
 * THE OTHER CHIP PANE, AND THE ONE THAT SETTLES THE ARGUMENT.
 *
 * Its paragraph wraps `Process Orchestrator` as the SECOND WORD, where pane 3
 * wraps `Form Builder` near the end. In French it wraps it after `L'` — an
 * elided article with NO trailing space, where English has `The ` with one.
 *
 * That single character is the whole case for `| translateParts` over a
 * per-fragment key scheme: a template that concatenated `prefix` + chip +
 * `suffix` would render `L' Orchestrateur de processus` to a French reader, and
 * nothing would fail. The translation owns its own spacing.
 * ---------------------------------------------------------------------------
 *
 * The bullets are in the source's DOM order, which is NOT its key order — the
 * highlighted `One event can touch several modules at once` was moved to the
 * front and the `data-i` numbering (`l3b` before `l3a`) left behind. The keys
 * here are named for what they say, so the two can no longer disagree.
 *
 * ⚠ The four-node chain is a still of `kz-drag-drop-canvas` (§12 #21). The
 * badge tones are decoration, not status — see `WalkthroughNodeTone`.
 */
@Component({
  selector: 'app-walkthrough-pane4',
  standalone: false,
  templateUrl: './walkthrough-pane4.component.html',
  styleUrls: ['./walkthrough-pane4.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane4Component {
  readonly nodes = FLOW_NODES;
}
